import React, { useState, useEffect } from "react";
import client from "../../../utils/prismicHelpers";
import "./healthTopCrd.css";
import * as queries from "../../../utils/prismicQueries";
const HealthTopCrd = ({ ifHealthCrd }) => {
  const [healthInfo, setHealthDoc] = useState(null);

  useEffect(() => {
    client
      .query({
        query: queries.healthTopCrd,
      })
      .then((response) => {
        const healthInfo = response.data.allHealths.edges[0].node;
        setHealthDoc(healthInfo);
      })
      .catch((error) => {
        console.error(error);
      });
  });

  return (
    <div
      className={`health-info d-flex ${
        ifHealthCrd && "mt-md-5"
      } mb-3 pb-md-0 justify-content-around align-items-center `}
    >
      <a
        target="_blank"
        className="text-decoration-none w-100"
        href="https://www.citizenshealth.in/"
      >
        <img
          src={healthInfo?.card_img2?.url}
          className="img-fluid w-75 logo2-img"
          alt="logo"
        />
      </a>
      <img
        src={healthInfo?.card_img1?.url}
        className="img-fluid logo-img"
        alt="logo"
      />
    </div>
  );
};

export default HealthTopCrd;
